import { GtmTracker } from '@/modules/common/services/analytics';

export const trackLastTransactionsAmplitudeEvent =
  GtmTracker.trackerWithDefaultProps({
    page_screen: 'last_movimentations',
    digital_experience: 'investor',
    experience_section: 'home'
  });

export const trackTransactionDetailsAmplitudeEvent =
  GtmTracker.trackerWithDefaultProps({
    page_screen: 'transaction_details',
    digital_experience: 'investor',
    experience_section: 'home'
  });
